import { array, object, string } from "yup"
import { useValidatorSeeker } from "@ui-seeker/app"

import { userSettingsOfficesGroupFormData } from "../@signals"


const schema = object({
	name: string().required('Name is required'),
	offices: array().min(1, 'Offices is required')
})

export default function useUserSettingsOfficesGroupValidator() {
	const { isValid, errors } = useValidatorSeeker(userSettingsOfficesGroupFormData.value, schema)

	return {
		isValid,
		nameError: errors.name || null,
		officesError: errors.offices || null
	}
}